import { Injectable } from '@angular/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';

@Injectable()
export class ConfiguredToastrService {

  constructor(private toastrService: ToastrService) {
  }

  error(message: string, title?: string) {
    return this.toastrService.error(message, title, {
      timeOut: 0,
      extendedTimeOut: 0,
      tapToDismiss: true
    });
  }

  toasts() {
    return this.toastrService.toasts;
  }

  clear(toast?: ActiveToast<any>) {
    if (toast) {
      this.toastrService.clear(toast.toastId);
    } else {
      this.toastrService.clear();
    }
  }

  info(message: string, title?: string, timeout = 20, tapToDismiss = false) {
    return this.toastrService.info(message, title, {
      timeOut: (tapToDismiss) ? 0 : timeout * 1000,
      extendedTimeOut: (tapToDismiss) ? 0 : 1000,
      tapToDismiss: tapToDismiss,
    });
  }

  success(message: string, title?: string, timeout = 20, tapToDismiss = false) {
    return this.toastrService.success(message, title, {
      timeOut: (tapToDismiss) ? 0 : timeout * 1000,
      extendedTimeOut: (tapToDismiss) ? 0 : 1000,
      tapToDismiss: tapToDismiss,
    });
  }

  warning(message: string, title?: string, timeout = 30, tapToDismiss = false) {
    return this.toastrService.warning(message, title, {
      timeOut: (tapToDismiss) ? 0 : timeout * 1000,
      extendedTimeOut: (tapToDismiss) ? 0 : 1000,
      tapToDismiss: tapToDismiss,
    });
  }
}
